import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserManageDataSource } from './user-manage-datasource';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user';
import { Utility } from 'src/app/models/utility';
import { Define } from '@app/models/define';
import { UserManageDialogComponent } from '../user-manage-dialog/user-manage-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ImportUserDialogComponent } from '../import-user-dialog/import-user-dialog.component';
import { TeamService } from '@app/services/team.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

export interface Organization {
  department: string;
  names: string[];
}

@Component({
  selector: 'app-user-manage',
  templateUrl: './user-manage.component.html',
  styleUrls: ['./user-manage.component.css'],
})
export class UserManageComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: UserManageDataSource;
  isAdmin: boolean;
  isHidden = true;
  searching = false;

  targets = ['社員番号', '氏名', 'ふりがな', '所属部署'];
  activeTarget = '社員番号';
  teamsForm: UntypedFormGroup;
  groups: Organization[] = [];
  groupsOptions: Observable<Organization[]>;
  selectedIndex = 0;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns: string[];

  _filter = (opt: string[], value: string): string[] => {
    // 全角文字 → 半角文字
    let afterValue = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    // 全角スペース → 半角スペース
    afterValue = afterValue.replace(/　/g, ' ');
    const filterValue = afterValue.toLowerCase();
    return opt.filter(item => item.toLowerCase().includes(filterValue));
  }

  constructor(private userService: UserService,
    private teamService: TeamService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.teamsForm = _formBuilder.group({
      'filterValue': '',
    });
  }

  async ngOnInit() {
    const teamDocs = await this.teamService.getTeams();
    const teams = teamDocs.map(val => val.name);
    this.dataSource = new UserManageDataSource(this.paginator, this.sort, []);
    this.isHidden = true;
    this.isAdmin = await this.userService.isAdminManageAuth();
    const manageAuth = await this.userService.getCurrentManageAuth();
    if (manageAuth === undefined || manageAuth < Define.ManageAuthority.Administrator) {
      this.displayedColumns = ['id', 'name', 'team', 'auth', 'manageAuth', 'tagId', 'normal-menu'];
    } else {
      this.displayedColumns = ['id', 'name', 'team', 'auth', 'manageAuth', 'tagId', 'admin-menu'];
    }

    teams.forEach(name => {
      // 半角・全角スペースで区切る
      if (name) {
        const groupName = name.split(/[ 　]/)[0];
        const index = this.groups.findIndex(val => val.department === groupName);

        if (index === -1) {
          this.groups.push({
            department: groupName,
            names: [name]
          });
        } else {
          this.groups[index].names.push(name);
        }
      }
    });
    this.groupsOptions = this.teamsForm.get('filterValue').valueChanges.pipe(
      startWith(''),
      map(value => this._filterGroup(value))
    );
  }

  getAuthName(num) {
    if (num === undefined) {
      return '';
    }
    const ret = Define.AuthorityName.find(elm => elm.id === num);
    if (ret === undefined) {
      return '';
    }
    return ret.value;

  }

  getManageAuthName(num) {
    if (num === undefined) {
      return '';
    }
    const ret = Define.ManageAuthorityName.find(elm => elm.id === num);
    if (ret === undefined) {
      return '';
    }
    return ret.value;
  }

  openDialog(rowData: User) {

    console.log(`openDialog open`);

    const data = Object.assign({}, rowData);
    const dialogRef = this.dialog.open(UserManageDialogComponent, { data });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`dialog close. result:${result}`);
      if (this.dataSource !== undefined && result === true) {
        this.ngOnInit();
      }
    });
  }

  delete(rowData: User) {
    console.log(`delete user`);
    console.log(rowData);
    const data = `ユーザー ${rowData.displayName} を削除します。この操作は元に戻せません。よろしいですか？`;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data });
    dialogRef.afterClosed().subscribe(async result => {
      if (this.dataSource !== undefined && result === true) {
        await this.userService.delete(rowData);
        console.log(`delete user execute`);
        this.ngOnInit();
      }
    });

  }

  resetPassword(rowData: User) {
    console.log(`passwordReset`);
    console.log(rowData);
    const data = `ユーザー ${rowData.displayName} のパスワードを初期化します。この操作は元に戻せません。よろしいですか？`;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        const newPassword = await this.userService.resetPassword(rowData);
        this.ngOnInit();
        console.log(`user password reset execute`);
        // console.log(newPassword);
        this.openSnackBar(`仮パスワード : ${newPassword}  をユーザーに通知してください。忘れた場合はもう一度パスワードリセットを行ってください。`, '確認');
      }
    });
  }

  import() {
    console.log(`import user start`);

    const dialogRef = this.dialog.open(ImportUserDialogComponent, {});
    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        console.log(`import user execute`);
        this.ngOnInit();
      } else if (result === false) {
        console.log(`import user cancel`);

      } else {
        console.log(`import user error`);
        this.openSnackBar('ICカードのKeyに重複・空白があるため、CSVをインポート出来ません。', '閉じる');
      }
    });
  }

  export() {
    // TODO CSVにユーザー一覧を出力する。
    const users = this.dataSource.data;
    const header = `uid,email,displayName,kana,key,id,teamName,authority,manageAuthority,password,withoutYakusya,bugyoParallelOperation\r\n`;
    let body = ``;
    users.forEach(user => {
      // tslint:disable-next-line:max-line-length
      body += `${user.uid},${user.email},${user.displayName},${user.kana},${user.key},${user.id},${user.teamName},${user.authority},${user.manageAuthority},,${user.withoutYakusya},${user.bugyoParallelOperation},\r\n`;
    });
    console.log(body);
    Utility.downloadText(header + body, 'users.csv', 'text/csv');
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  _filterGroup(value: string): Organization[] {
    if (value) {
      return this.groups
        .map(group => ({
          department: group.department,
          names: this._filter(group.names, value)
        }))
        .filter(group => {
          if (group.names.length > 0) {
            return true;
          } else {
            return false;
          }
        });
    }

    return this.groups;
  }

  async onSubmit() {
    this.searching = true;
    const data = await this.userService.getUsersWithFilter(
      this.targets.findIndex(val => val === this.activeTarget),
      this.teamsForm.value.filterValue);
    this.dataSource = new UserManageDataSource(this.paginator, this.sort, data);
    this.isHidden = false;
    this.searching = false;
  }

  async loadAllUser() {
    this.searching = true;
    const data = await this.userService.getUsers();
    this.dataSource = new UserManageDataSource(this.paginator, this.sort, data);
    this.isHidden = false;
    this.searching = false;
  }

}
